export default     {
    path: 'processes',
    name: 'processes',
    component: () => import(/* webpackChunkName: "bpmnIndex" */ '@/views/admin/BpmnProcesses/index.vue'),
    children:[
        {
            name: 'main',
            path: 'main',
            component: () => import(/* webpackChunkName: "bpmnProcesses" */ '@/views/admin/BpmnProcesses/BpmnProcesses.vue'),
            props: true,
        }
    ]
};
